import React from 'react'
import { createBrowserRouter, RouterProvider } from 'react-router-dom'
import { routeDefinitions } from './routeDefinitions'

const router = createBrowserRouter(routeDefinitions)

export const AppRouter: React.FC = () => {
  return <RouterProvider router={router} />
}
